import { render, staticRenderFns } from "./AddMessageReply.vue?vue&type=template&id=cc32cb72&"
import script from "./AddMessageReply.vue?vue&type=script&lang=js&"
export * from "./AddMessageReply.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\RobertWiberg\\source\\repos\\server-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cc32cb72')) {
      api.createRecord('cc32cb72', component.options)
    } else {
      api.reload('cc32cb72', component.options)
    }
    module.hot.accept("./AddMessageReply.vue?vue&type=template&id=cc32cb72&", function () {
      api.rerender('cc32cb72', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Compose/AddMessageReply.vue"
export default component.exports